<template>
  <div>
    <div class="loading" v-show="!showCarousel">Loading....</div>
    <transition name="fade" mode="out-in">
    <div class="book-carousel" v-images-loaded="imagesHaveLoaded" v-show="showCarousel">
      <div class="book-cell" v-for="book in books" :key="book.url" :data-url="'/' + book.year + '/' + book.url">
        <a :href="'/' + book.year + '/' + book.url" @click="followLink">
          <img class="book-cell-image" :src="'/imgfly/' + book.image + '?h=718'"/>
          <span class="title">{{ book.name }}</span>
        </a>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
  var Flickity = require('flickity');
  require('flickity-imagesloaded');
  import imagesLoaded from 'vue-images-loaded';

  export default {
    name: 'BookGallery',
    directives: {
      imagesLoaded
    },
    props: {
      year: {
        required: true
      }
    },
    data : function() {
      return {
        books: [],
        flkty: null,
        showCarousel:false
      }
    },
    mounted() {
      this.books = gbl.years[this.year];
    },
    methods: {
      initialiseFlickity() {
        this.$nextTick()
          .then(() => {
            let options = { "wrapAround": true, "pageDots": false, imagesLoaded: true, initialIndex: 1 };
            const route = this.$route.fullPath;
            if(localStorage.getItem(route)) {
              options.initialIndex = parseInt(localStorage.getItem(route));
            }
            this.flkty = new Flickity( '.book-carousel', options);
            const bookImgs = document.getElementsByClassName("book-cell-image");
            let width = 0;
            for(var i = 0; i < bookImgs.length; i++) {
              width += bookImgs[i].offsetWidth;
            }
            if(width < window.innerWidth) {
              this.flkty.destroy();
              options.wrapAround = false;
              this.flkty = new Flickity( '.book-carousel', options);
            }
            this.flkty.on( 'staticClick', ( event, pointer, cellElement, cellIndex ) => {
              this.$router.push({path:cellElement.dataset.url});
            });
            this.flkty.on( 'change', ( index ) => {
              localStorage.setItem(route, index);
            });
          });
      },
      followLink($event) {
        if(window.innerWidth > 640) {
          $event.preventDefault();
        }
      },
      imagesHaveLoaded() {
        this.showCarousel = true;
        if(window.innerWidth > 640) {
          this.initialiseFlickity();
        }
      }
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/js/components/BookGallery.vue